<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.Bank.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtBankName"><small class="text-danger">*</small> {{$lang.Bank.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtBankName"
                              :placeholder="$lang.Bank.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtCode"><small class="text-danger">*</small> {{$lang.Bank.LabelCode}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              id="txtCode"
                              name="txtCode"
                              :placeholder="$lang.Bank.PlaceholderEnterMnemonic"
                              v-model="form.code.value"
                              :size="form.code.maxlength"
                              :required="form.code.required"
                              :state="form.code.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtAcronym"> {{$lang.Bank.LabelAcronym}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              id="txtAcronym"
                              name="txtAcronym"
                              :placeholder="$lang.Bank.PlaceholderEnterAcronym"
                              v-model="form.acronym.value"
                              :size="form.acronym.maxlength"
                              :required="form.acronym.required"
                              :state="form.acronym.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.Bank.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.Bank.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.Bank.DataTable.Name,
                       $lang.Bank.DataTable.Code,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.AccountAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.code" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)" :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Bank from './bank.js'

export default Bank
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/bank/bank.vue